export default {
  "living": "1",
  "banner": {
    "pc": "https://static.geekbang.org/infoq/5be9664c33d0f.png?imageView2/0/",
    "mobile": "https://static.geekbang.org/infoq/5bea9049a6af5.png?imageView2/0/"
  },
  "intro": {
    "title": "大会介绍",
    "bgpc": "https://static.geekbang.org/infoq/5be57ade507ad.png",
    "bgmobile": "http://static.geekbang.org/infoq/5a0527b12b47f.png",
    "content": "2018年11月14日-15日，2018英特尔® 人工智能大会将于在北京国贸大酒店盛大开启。这场世界级的人工智能盛会将汇聚业界近2000多名国内外人工智能领域最具影响力的专家学者，行业领袖，架构工程师，高级数据分析师，高级技术工程师及媒体共同参与此次盛会，同时大会也邀请了30多家合作伙伴共同展示人工智能领域的最新解决方案，产品及技术应用，此次大会将围绕人工智能领域的技术前沿、产业趋势和热点问题进行分享，您可以和众多重量级嘉宾以及行业专家进行面对面交流，共同打造世界顶尖的人工智能合作交流平台。",
    "moreIntroduce": [
      {
        "title": "英特尔® 人工智能大会·主论坛",
        "desc": "14日Keynote内容将从如何突破理论践行AI、从人工智能到超级大脑、数据时代的人工智能产品创新与实践等展开，剖析英特尔如何探索自然和人类、已知和未知的领域、驱动产业的智能升级。15日Keynote内容将从人工智能和大数据的革新、以物理学和隐私等维度看人工智能、数据科学实现的开源工具、百度大规模深度学习应用实践和开源AI框架PaddlePaddle、智能时代的计算演进等内容展开，剖析人工智能前沿技术、产业趋势和热点问题。"
      },
      {
        "title": "",
        "desc": ""
      },
      {
        "title": "五大技术分论坛",
        "desc": "五大技术分论坛从核心技术、实践方向、趋势探讨、落地应用等几大维度勾勒英特尔人工智能版图，及知名互联网企业（如爱奇艺、第四范式、阿里云等）在AI领域的技术实现方案，看他们如何推动社会变革，为产业赋能。"
      }
    ]
  },
  "schedule": {
    "day1": {
      "1": {
        "name": "会场一",
        "schtitle": "主论坛",
        "roomid": "54188D34AE7AB0FE9C33DC5901307461",
        "vid": "2B15342F30D325479C33DC5901307461",
        "mask": "https://static.geekbang.org/infoq/5bea401edfe42.png",
        "status": "playback",
        "schs": [
          [
            "13:30-13:45",
            "欢迎致辞 — AI，在实践中前行\n",
            "杨旭，英特尔公司全球副总裁兼中国区总裁"
          ],
          [
            "13:45-15:15",
            "突破理论，践行AI",
            "Naveen Rao，英特尔公司全球副总裁兼人工智能产品事业部总经理"
          ],
          [
            "15:30-15:45",
            "关于深度学习的一点思考",
            "周志华，南京大学人工智能学院院长，计算机科学及技术系主任（注：现在是南京大学周志华教授在发表主题演讲，应本人要求不做现场直播，请您观看视频了解英特尔公司与南京大学在机器学习领域全新合作的案例，以及案例中相关英特尔人工智能产品和技术的介绍）"
          ],
          [
            "15:45-16:15",
            "从人工智能到超级大脑",
            "王龙，腾讯云副总裁"
          ],
          [
            "16:15-16:45",
            "数据时代，人工智能产品创新与实践",
            "Jonathan Ballon，英特尔物联网事业部副总裁"
          ]
        ]
      },
      "date": {
        "yyyy": "2018",
        "MM": "11",
        "dd": "14",
        "duration": "13:30-16:45 PM"
      }
    },
    "day2": {
      "1": {
        "name": "会场一",
        "schtitle": "主论坛",
        "roomid": "54188D34AE7AB0FE9C33DC5901307461",
        "vid": "110F9344DBA7F5279C33DC5901307461",
        "mask": "https://static.geekbang.org/infoq/5bea401e34893.png",
        "status": "playback",
        "schs": [
          [
            "09:00-09:45",
            "人工智能和大数据的革新\n",
            "戴金权，英特尔高级首席工程师、大数据技术全球CTO"
          ],
          [
            "09:45-10:15",
            "人工智能研究：物理学、隐私和大脑",
            "Casimir Wierzynski，英特尔人工智能产品事业部全球研究负责人"
          ],
          [
            "10:15-10:45",
            "数据科学实践的开源工具",
            "刘茵茵,  英特尔人工智能产品事业部全球数据科学负责人"
          ],
          [
            "10:45-11:15",
            "百度大规模深度学习应用实践和开源AI框架PaddlePaddle",
            "于佃海, PaddlePaddle技术负责人，百度NLP技术委员会主席"
          ],
          [
            "11:15-12:00",
            "智能时代的计算演进",
            "宋继强，英特尔中国研究院院长"
          ]
        ]
      },
      "date": {
        "yyyy": "2018",
        "MM": "11",
        "dd": "15",
        "duration": "9:00-12:00 AM"
      }
    },
    "day3": {
      "1": {
        "name": "会场一",
        "schtitle": "国际论坛",
        "roomid": "54188D34AE7AB0FE9C33DC5901307461",
        "vid": "01C8D10F0F88DD299C33DC5901307461",
        "mask": "https://static.geekbang.org/infoq/5bf0bc2c31529.png?imageView2/0/",
        "status": "playback",
        "schs": [
          [
            "13:30-14:10",
            "英特尔® 至强® 可扩展平台AI性能介绍\n",
            "Ananth Sankaranarayanan，Stephen Thome（英特尔）"
          ],
          [
            "14:10-14:20",
            "休息",
            ""
          ],
          [
            "14:20-15:00",
            "Neural Network Distiller: a PyTorch Environment for Neural Network Compression",
            "Neta Zmora（英特尔）"
          ],
          [
            "15:00-15:10",
            "休息",
            ""
          ],
          [
            "15:10-15:50",
            "Intel® AI for Good",
            "Anna Bethke（英特尔）"
          ],
          [
            "15:50-16:00",
            "休息",
            ""
          ],
          [
            "16:00-16:40",
            "The AI Journey with Intel Open Source Software",
            "Nicholas Della Cioppa（英特尔）"
          ],
          [
            "16:40-16:50",
            "休息",
            ""
          ],
          [
            "16:50-17:30",
            "基于英特尔至强处理器超算的高效神经网络学习",
            "李三平，Paul Rietze，Ananth（戴尔，英特尔，英特尔）"
          ]
        ]
      },
      "2": {
        "name": "会场二",
        "schtitle": "学术论坛",
        "roomid": "BC1D91A96A169A7C9C33DC5901307461",
        "vid": "7E321C983C5CAD119C33DC5901307461",
        "mask": "https://static.geekbang.org/infoq/5bea401f39cdc.png",
        "status": "playback",
        "schs": [
          [
            "13:30-14:10",
            "语音模型中的迁移学习\n",
            "陶建华（中国科学院自动化研究所）"
          ],
          [
            "14:10-14:20",
            "休息",
            ""
          ],
          [
            "14:20-15:00",
            "特征抽取与边框回归：目标检测方法新进展",
            "王勇涛（北京大学）"
          ],
          [
            "15:00-15:10",
            "休息",
            ""
          ],
          [
            "15:10-15:50",
            "高能效智能感知系统信号处理框架和集成电路设计",
            "乔飞（清华大学）"
          ],
          [
            "15:50-16:00",
            "休息",
            ""
          ],
          [
            "16:00-16:40",
            "深度神经网络计算优化",
            "程健（中国科学院自动化研究所）"
          ],
          [
            "16:40-16:50",
            "休息",
            ""
          ],
          [
            "16:50-17:30",
            "跨媒体关联分析与智能",
            "朱文武, 王鑫（清华大学）"
          ]
        ]
      },
      "3": {
        "name": "会场三",
        "schtitle": "解决方案论坛",
        "roomid": "28B7594B343BE6FA9C33DC5901307461",
        "vid": "77E790D4DAF3F0FC9C33DC5901307461",
        "mask": "https://static.geekbang.org/infoq/5bea755cdaf99.png",
        "status": "playback",
        "schs": [
          [
            "13:30-13:45",
            "爱奇艺AI视频云架构实践",
            "周海维（爱奇艺）"
          ],
          [
            "13:45-13:55",
            "休息",
            ""
          ],
          [
            "13:55-14:40",
            "在边缘实现深度学习的前沿研究",
            "陈玉荣（英特尔）"
          ],
          [
            "14:40-14:55",
            "休息",
            ""
          ],
          [
            "14:55-15:40",
            "人工智能在医学影像中的应用实践",
            "张云星（西安盈谷网络科技有限公司）"
          ],
          [
            "15:40-15:50",
            "休息",
            ""
          ],
          [
            "15:50-16:35",
            "英特尔人工智能在金融行业的应用",
            "俞巍（英特尔）"
          ],
          [
            "16:35-16:45",
            "休息",
            ""
          ],
          [
            "16:45-17:30",
            "智能化基础平台，加速企业AI布局",
            "王璞（优刻得科技股份有限公司）"
          ]
        ]
      },
      "4": {
        "name": "会场四",
        "schtitle": "软件论坛",
        "roomid": "AF5F603CCC7101D29C33DC5901307461",
        "vid": "13100CAAA6E109769C33DC5901307461",
        "mask": "https://static.geekbang.org/infoq/5bea755d61374.png",
        "status": "playback",
        "schs": [
          [
            "13:30-13:45",
            "从边缘到云端，使用Intel® OpenVINO™ 加速AI应用模型推理",
            "赵桢（爱奇艺）"
          ],
          [
            "13:45-13:55",
            "休息",
            ""
          ],
          [
            "13:55-14:40",
            "基于Apache Spark和BigDL的数据分析及人工智能流水线",
            "乐鹏飞，江宇（英特尔，阿里云）"
          ],
          [
            "14:40-14:55",
            "休息",
            ""
          ],
          [
            "14:55-15:40",
            "破解AI商业化困境之利器—AutoML",
            "涂威威（第四范式）"
          ],
          [
            "15:40-15:50",
            "休息",
            ""
          ],
          [
            "15:50-16:35",
            "英特尔® 至强® 平台的Tensorflow优化",
            "傅晟（英特尔）"
          ],
          [
            "16:35-16:45",
            "休息",
            ""
          ],
          [
            "16:45-17:30",
            "英特尔® 至强® 平台基于nGraph的分布式TensorFlow训练",
            "薛文哲（英特尔）"
          ]
        ]
      },
      "5": {
        "name": "会场五",
        "schtitle": "平台论坛",
        "roomid": "98936869E6ADF8449C33DC5901307461",
        "vid": "6EE788D52A0FB7A89C33DC5901307461",
        "mask": "https://static.geekbang.org/infoq/5bea755c8f870.png",
        "status": "playback",
        "schs": [
          [
            "13:30-13:45",
            "MyriadX概述和3D卷积神经网络在Myriad X上的实现",
            "李卫锋（英特尔）"
          ],
          [
            "13:45-13:55",
            "休息",
            ""
          ],
          [
            "13:55-14:40",
            "英特尔® FPGA赋能人工智能 ",
            "刘斌（英特尔）"
          ],
          [
            "14:40-14:55",
            "休息",
            ""
          ],
          [
            "14:55-15:40",
            "英特尔® DL Boost® 指令及其在深度学习中的应用",
            "姚伟峰（英特尔）"
          ],
          [
            "15:40-15:50",
            "休息",
            ""
          ],
          [
            "15:50-16:35",
            "英特尔® 物联网视频解决方案介绍",
            "何轲（英特尔）"
          ],
          [
            "16:35-16:45",
            "休息",
            ""
          ],
          [
            "16:45-17:30",
            "英特尔人工智能开发者伙伴计划介绍",
            "程序（英特尔）"
          ]
        ]
      },
      "date": {
        "yyyy": "2018",
        "MM": "11",
        "dd": "15",
        "duration": "13:30-17:30 PM"
      }
    },
    "title": "英特尔® 人工智能大会直播",
    "imgpc": "http://static.geekbang.org/infoq/5a0527c2b30ae.png",
    "imgmobile": "http://static.geekbang.org/infoq/5a0527bfe71f6.png"
  },
  "members": [
    {
      "name": "杨旭",
      "urllink": "https://bizwebcast.intel.cn/aidc/index.aspx?utm_source=sem&cid=prc:baibiz_cn_aidccn2378e0s&utm_source=baidu&utm_medium=cpc&utm_term=cv_biz_ai_227552&utm_campaign=biz_cn_aidcs&utm_content=cid=prc:baibiz_cn_aidccn2378e0s&intel_term=intel%20ai",
      "imgUrl": "https://static.geekbang.org/infoq/5bea3343f0642.png?imageView2/0/w/800",
      "brief": "",
      "company": "英特尔\n",
      "profile": "英特尔公司全球副总裁兼中国区总裁"
    },
    {
      "name": "Naveen Rao",
      "urllink": "https://bizwebcast.intel.cn/aidc/index.aspx?utm_source=sem&cid=prc:baibiz_cn_aidccn2378e0s&utm_source=baidu&utm_medium=cpc&utm_term=cv_biz_ai_227552&utm_campaign=biz_cn_aidcs&utm_content=cid=prc:baibiz_cn_aidccn2378e0s&intel_term=intel%20ai",
      "imgUrl": "https://static.geekbang.org/infoq/5bea3329984de.png?imageView2/0/w/800",
      "brief": "",
      "company": "英特尔",
      "profile": "英特尔公司全球副总裁兼人工智能产品事业部总经理"
    },
    {
      "name": "王龙",
      "urllink": "https://bizwebcast.intel.cn/aidc/index.aspx?utm_source=sem&cid=prc:baibiz_cn_aidccn2378e0s&utm_source=baidu&utm_medium=cpc&utm_term=cv_biz_ai_227552&utm_campaign=biz_cn_aidcs&utm_content=cid=prc:baibiz_cn_aidccn2378e0s&intel_term=intel%20ai",
      "imgUrl": "https://static.geekbang.org/infoq/5bea334458583.png?imageView2/0/w/800",
      "brief": "",
      "company": "腾讯云",
      "profile": "副总裁"
    },
    {
      "name": "Jonathan Ballon",
      "urllink": "https://bizwebcast.intel.cn/aidc/index.aspx?utm_source=sem&cid=prc:baibiz_cn_aidccn2378e0s&utm_source=baidu&utm_medium=cpc&utm_term=cv_biz_ai_227552&utm_campaign=biz_cn_aidcs&utm_content=cid=prc:baibiz_cn_aidccn2378e0s&intel_term=intel%20ai",
      "imgUrl": "https://static.geekbang.org/infoq/5bea332a602af.png?imageView2/0/w/800",
      "brief": "",
      "company": "英特尔",
      "profile": "英特尔公司物联网事业部副总裁 \n"
    },
    {
      "name": "戴金权 ",
      "urllink": "https://bizwebcast.intel.cn/aidc/index.aspx?utm_source=sem&cid=prc:baibiz_cn_aidccn2378e0s&utm_source=baidu&utm_medium=cpc&utm_term=cv_biz_ai_227552&utm_campaign=biz_cn_aidcs&utm_content=cid=prc:baibiz_cn_aidccn2378e0s&intel_term=intel%20ai",
      "imgUrl": "https://static.geekbang.org/infoq/5bea3329e7525.png?imageView2/0/w/800",
      "brief": "",
      "company": "英特尔 \n",
      "profile": "英特尔软件和服务事业部高级首席工程师、大数据技术全球CTO "
    },
    {
      "name": "刘茵茵",
      "urllink": "https://bizwebcast.intel.cn/aidc/index.aspx?utm_source=sem&cid=prc:baibiz_cn_aidccn2378e0s&utm_source=baidu&utm_medium=cpc&utm_term=cv_biz_ai_227552&utm_campaign=biz_cn_aidcs&utm_content=cid=prc:baibiz_cn_aidccn2378e0s&intel_term=intel%20ai",
      "imgUrl": "https://static.geekbang.org/infoq/5bea36852d8df.png?imageView2/0/w/800",
      "brief": "",
      "company": "英特尔",
      "profile": "英特尔人工智能产品事业部全球数据科学负责人"
    },
    {
      "name": "于佃海 ",
      "urllink": "https://bizwebcast.intel.cn/aidc/index.aspx?utm_source=sem&cid=prc:baibiz_cn_aidccn2378e0s&utm_source=baidu&utm_medium=cpc&utm_term=cv_biz_ai_227552&utm_campaign=biz_cn_aidcs&utm_content=cid=prc:baibiz_cn_aidccn2378e0s&intel_term=intel%20ai",
      "imgUrl": "https://static.geekbang.org/infoq/5bea367637a9d.png?imageView2/0/w/800",
      "brief": "",
      "company": "百度",
      "profile": "PaddlePaddle技术负责人（总架构师），\n百度NLP技术委员会主席"
    },
    {
      "name": "宋继强 ",
      "urllink": "https://bizwebcast.intel.cn/aidc/index.aspx?utm_source=sem&cid=prc:baibiz_cn_aidccn2378e0s&utm_source=baidu&utm_medium=cpc&utm_term=cv_biz_ai_227552&utm_campaign=biz_cn_aidcs&utm_content=cid=prc:baibiz_cn_aidccn2378e0s&intel_term=intel%20ai",
      "imgUrl": "https://static.geekbang.org/infoq/5bea3675cddad.png?imageView2/0/w/800",
      "brief": "",
      "company": "英特尔\n",
      "profile": "英特尔中国研究院院长 \n"
    }
  ],
  "intro2": {
    "title": "更多阅读",
    "list": [
      {
        "img": "https://static.geekbang.org/infoq/5be9679d412b5.png?imageView2/0/w/800",
        "title": "西安盈谷基于 CPU 分析医疗影像，实现快速辅助诊断",
        "intro": "西安盈谷基于英特尔® 至强® 可扩展处理器和 Tensorflow* 等深度学习框架， 打造医疗智能化辅助诊断系统，实时处理，高效分析云上海量医疗影像，支持各级医疗机构跨终端和跨平台应用。",
        "link": "https://www.intel.cn/content/www/cn/zh/analytics/artificial-intelligence/yinggu-case-study-medical.html?utm_campaign=2018_q4_aipg_cn_dcgai3_na_AI_na&utm_source=InfoQ&utm_content=o_dss_fpos_cn_bus_custom_18_q4_1_banner_tracking_InfoQ_broadcast_yinggu&utm_medium=display&cid=2018_q4_artificial-intelligence-products-group-aipg_china-prc_dcg-artificial-intelligence-campaign_AI_na",
        "more": "点击阅读 >"
      },
      {
        "img": "https://static.geekbang.org/infoq/5bea384b24a07.png?imageView2/0/w/800",
        "title": "UCloud 基于 CPU 部署 AI 云，灵活高效 TCO",
        "intro": "UCloud AI 云服务基于英特尔® 至强® 可扩展处理器和 AVX-512 技术，在图像识别，机器学习等多个领域满足初创企业和传统企业转型的不同需求，灵活高效，节约成本。",
        "link": "https://www.intel.cn/content/www/cn/zh/cloud-computing/the-cloud-g-star.html?utm_campaign=2018_q4_aipg_cn_dcgai3_na_AI_na&utm_source=InfoQ&utm_content=o_dss_fpos_cn_bus_custom_18_q4_2_banner_tracking_InfoQ_broadcast_ucloud&utm_medium=display&cid=2018_q4_artificial-intelligence-products-group-aipg_china-prc_dcg-artificial-intelligence-campaign_AI_na",
        "more": "点击阅读 >"
      },
      {
        "img": "https://static.geekbang.org/infoq/5bea384bc3ab5.png?imageView2/0/w/800",
        "title": "科大讯飞基于 CPU 构建 AI 开放平台，加速开发者创新",
        "intro": "科大讯飞基于英特尔® 至强® 可扩展处理器和软件工具打造灵活，可扩展的 AI 开放平台，支持多样化 AI 应用负载。",
        "link": "https://www.intel.cn/content/www/cn/zh/analytics/artificial-intelligence/iflytek-based-on-intel-xeon-phi-processor-optimized-deep-learning-platform.html?utm_campaign=2018_q4_aipg_cn_dcgai3_na_AI_na&utm_source=InfoQ&utm_content=o_dss_fpos_cn_bus_custom_18_q4_3_banner_tracking_InfoQ_broadcast_kedaxunfei&utm_medium=display&cid=2018_q4_artificial-intelligence-products-group-aipg_china-prc_dcg-artificial-intelligence-campaign_AI_na",
        "more": "点击阅读 >"
      },
      {
        "img": "https://static.geekbang.org/infoq/5bea384c7bfd9.png?imageView2/0/w/800",
        "title": "中国银联重塑金融反欺诈模型，效果显著提升",
        "intro": "中国银联利用英特尔® 至强® 可扩展处理器和优化的软件和工具：BigDL, Tensorflow*, 英特尔® Python 发行版等，重塑金融反欺诈模型，高效识别和应对新兴威胁。",
        "link": "https://www.intel.cn/content/www/cn/zh/analytics/artificial-intelligence/solutions/fraud-detection-models-case-study.html?utm_campaign=2018_q4_aipg_cn_dcgai3_na_AI_na&utm_source=InfoQ&utm_content=o_dss_fpos_cn_bus_custom_18_q4_4_banner_tracking_InfoQ_broadcast_unionpay&utm_medium=display&cid=2018_q4_artificial-intelligence-products-group-aipg_china-prc_dcg-artificial-intelligence-campaign_AI_na",
        "more": "点击阅读 >"
      },
      {
        "img": "https://static.geekbang.org/infoq/5bea384c3336a.png?imageView2/0/w/800",
        "title": "爱尔眼科利用 AI 识别糖尿病眼底病变，准确率大幅提升",
        "intro": "爱尔眼科医院采用英特尔® 至强® 可扩展处理器，针对英特尔® 架构优化的 Caffe* 和英特尔® 数学核心函数库 MKL，开发深度学习方案实现高效经济的眼部健康筛查，预防失明。",
        "link": "https://www.intel.cn/content/www/cn/zh/analytics/artificial-intelligence/aier-eye-hospital-brings-deep-learning-to-blindness-prevention-case-study.html?utm_campaign=2018_q4_aipg_cn_dcgai3_na_AI_na&utm_source=InfoQ&utm_content=o_dss_fpos_cn_bus_custom_18_q4_5_banner_tracking_InfoQ_broadcast_aier&utm_medium=display&cid=2018_q4_artificial-intelligence-products-group-aipg_china-prc_dcg-artificial-intelligence-campaign_AI_na",
        "more": "点击阅读 >"
      },
      {
        "img": "https://static.geekbang.org/infoq/5bea384b623d3.png?imageView2/0/w/800",
        "title": "助力无界零售，加速智能图像分析",
        "intro": "京东在基于英特尔® 至强® 处理器的图像存储服务器上部署 BigDL 分布式深度学习框架，显著提高智能图像分析性能，并易于管理和扩展，敏捷使用产品图像创新零售服务。",
        "link": "https://www.intel.cn/content/www/cn/zh/analytics/artificial-intelligence/jd-replacing-gpus-with-cpus-case-study-v2.html?utm_campaign=2018_q4_aipg_cn_dcgai3_na_AI_na&utm_source=InfoQ&utm_content=o_dss_fpos_cn_bus_custom_18_q4_6_banner_tracking_InfoQ_broadcast_JD&utm_medium=display&cid=2018_q4_artificial-intelligence-products-group-aipg_china-prc_dcg-artificial-intelligence-campaign_AI_na",
        "more": "点击阅读 >"
      }
    ]
  },
  "image": {
    "title": "现场图集",
    "intro": "使关键网络应用的IPSec转发速率提升最高达2.5倍，整体性能提升达1.65倍，从而提高网络转型的价值。此外，其拥有多达28颗内核，并针对数据中心和通信网络中各种性能需求进行了优化，可提供2插槽到8插槽及更多插槽配置支持和充足的扩展空间。",
    "imgs": [
      "http://www.infoq.com/cn/zones/baidu-ai/img/ai-l.jpg",
      "http://www.infoq.com/cn/zones/baidu-ai/img/sol-1.jpg",
      "http://www.infoq.com/cn/zones/baidu-ai/img/sol-2.jpg",
      "http://www.infoq.com/cn/zones/baidu-ai/img/sol-3.jpg",
      "http://www.infoq.com/cn/zones/baidu-ai/img/sol-4.jpg"
    ]
  }
}


// WEBPACK FOOTER //
// ./src/data.js